export default {
  // 首页
  aboutus: "关于我们",
  contactus:"联系我们",
  downpdf:"下载PDF",
  getData:"获取资料",
  news: "新闻资讯",
  address:"北京朝阳区望京街道望京SOHO T1C座1012",
  messageBord:"留言板",
  username:"姓名",
  phone:"电话",
  email:"邮箱",
  message:"留言",
  submit:"提交",
  pleaseLeave:"请留下您的联系方式",
  pleaseCorrect:"请提供正确的邮箱地址，便于我们与您联系",
  submitSuccess:"提交成功",
  bottom:"© 2024 FUTURE CITIZEN BUREAU 保留所有权利",
  newsPrev:"上一篇",
  newsNext:"下一篇",
  newsReturnList:"返回列表",
  LearnMore:"查看更多",
  showDetail:"查看详情",
  irelandProject:"爱尔兰项目",
  vanuatuProject:"瓦努阿图项目",
  service_content:"服务内容",
  cooperateAdv:"合作优势",
  bahamas:"巴哈马",
  slovenia:"斯洛文尼亚",
  ireland:"爱尔兰",
  vanuatu:"瓦努阿图",
  projectPlan:"项目计划",
  projectOverview:"项目概况",
  applicant:"申请条件",
  moreNews:"更多新闻动态",
};
